import { ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { SingleActionDialogModel } from '../../../interfaces/dialogs/single-action-dialog.model';
import { MatButton } from '@angular/material/button';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

/**
 * 單一按鈕通用dialog組件，對應樣式A
 */
@Component({
  selector: 'app-home-router-dialog',
  standalone: true,
  imports: [MatDialogContent, MatButton, TranslatePipe],
  templateUrl: './home-router-dialog.html',
  styleUrl: './home-router-dialog.scss',
})
export class HomeRouterDialogComponent implements OnInit, OnDestroy {
  submitAction: boolean = false;
  qrCodeStatus: boolean = false;
  safeQrCodeUrl: SafeUrl | null = null;
  // --- 倒數計時相關變數 ---
  @Output() refreshQrCode = new EventEmitter<void>();//定義 Output 事件，通知父元件重新呼叫 API
  remainingSeconds: number = 300; // 5分鐘 = 300秒
  countdownText: string = '05:00'; // 顯示在畫面上的字串
  timerInterval: any; // 計時器變數
  isQrCodeDisabled: boolean = false; // 紀錄 QR Code 是否已過期失效
  constructor(
    translateService: TranslateService,
    public dialogRef: MatDialogRef<HomeRouterDialogComponent>,
    private sanitizer: DomSanitizer,// 注入 Sanitizer
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: SingleActionDialogModel
  ) {
    console.log('dialog data', data);
  }

  ngOnInit(): void {

    this.handleQrCodeImage(this.data.qrCodeImg);
    //  元件初始化時啟動倒數計時
    this.startCountdown();
  }

  // 處理與轉換圖片安全網址
  handleQrCodeImage(imgUrl: string | undefined) {
    if (imgUrl) {
      this.safeQrCodeUrl = this.sanitizer.bypassSecurityTrustUrl(imgUrl);
    }
  }
  close() {
    if (this.data.closeAction) {
      this.data.closeAction();
    } else {
      this.dialogRef.close();
    }
  }

  // 前往舊web預約
  goToOldWeb() {
    window.location.href = 'https://booking.cathay-hcm.com.tw/booking/person';
  }

  // 倒數計時邏輯
  startCountdown() {
    this.clearTimer();
    this.isQrCodeDisabled = false;
    this.remainingSeconds = 300;
    this.updateCountdownText();

    this.timerInterval = setInterval(() => {
      if (this.remainingSeconds > 0) {
        this.remainingSeconds--;
        this.updateCountdownText();
      } else {
        this.clearTimer();
        this.handleTimeUp();
      }
    }, 1000);
  }

  // 4. 點擊畫面上的 Refresh 按鈕時觸發
  onRefresh() {
    // 發射事件給父元件，讓父元件去打 API
    this.refreshQrCode.emit();
  }
  
  // 清除計時器並重置狀態
  clearTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
  // 轉化成 mm:ss 格式
  updateCountdownText() {
    const minutes = Math.floor(this.remainingSeconds / 60);
    const seconds = this.remainingSeconds % 60;

    // 使用 padStart 補足兩位數，例如： 5 變成 "05"
    const displayMinutes = String(minutes).padStart(2, '0');
    const displaySeconds = String(seconds).padStart(2, '0');

    this.countdownText = `${displayMinutes}:${displaySeconds}`;
  }
// 5. 提供給父元件呼叫的方法：當父元件打完 API 取得新資料後，可以用這個方法重新餵入新圖片並重置倒數
  public updateAndReset(newImgUrl: string) {
    this.handleQrCodeImage(newImgUrl);
    this.startCountdown();
  }
  // 時間到的處理邏輯（看你要自動關閉還是做其他事）
handleTimeUp() {
    this.isQrCodeDisabled = true;
    this.cdr.detectChanges();
    console.log('QR Code 已過期失效');
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
}
